import { queryOptions } from '@tanstack/react-query';
import { identidadeService } from './services/identidadeService';

export const identidadeQueries = {
  all: () => ['identidade'] as const,
  // staleTime 0: o vínculo é refeito a cada abertura da página (spec 01 §6).
  atual: () =>
    queryOptions({
      queryKey: [...identidadeQueries.all(), 'atual'] as const,
      queryFn: () => identidadeService.atual(),
      staleTime: 0,
      retry: false,
    }),
};
